@@include('../../plugins/swiper.v11.1.5/swiper-bundle.min.js')
@@include('../../plugins/nouislider.v15.7.0/nouislider.min.js')
@@include('../../plugins/imask.v7.1.3.min.js')
@@include('../../plugins/autosize.min.js')
@@include('../../plugins/overlayscrollbars/overlayscrollbars.browser.es6.min.js')

@@include('../../plugins/gsap/gsap.min.js')
@@include('../../plugins/gsap/ScrollTrigger.min.js')

@@include('../../plugins/lenis.min.js')

@@include('../../plugins/fancybox/fancybox.umd.js')